import { Box, IconButton, Tooltip } from "@mui/material"
import MaterialReactTable from "material-react-table"
import React, { useCallback, useMemo } from "react"
//Import Material React Table Translations
import VisibilityIcon from "@mui/icons-material/Visibility"
import { darken } from "@mui/material"
import { MRT_Localization_ES } from "material-react-table/locales/es"

const TablaLicencias = ({ columnas, lineas, handleOpen, acciones = false }) => {
  const [data, setData] = React.useState([])
  const columns = useMemo(() => columnas, [columnas])
  const [pagination, setPagination] = React.useState({
    pageIndex: 0,
    pageSize: 5,
  })

  React.useEffect(() => {
    if (lineas.length > 0) {
      setData(lineas)
    }
  }, [lineas])

  //abrir modal
  const openModal = (row) => {
    let id = row.original.id
    handleOpen(id, row.original)
  }

  return (
    <>
      <MaterialReactTable
        muiTablePaginationProps={{
          rowsPerPageOptions: [5, 10],
        }}
        // onPaginationChange={setPagination} //hoist pagination state to your state when it changes internally
        columns={columns}
        data={data}
        muiTablePaperProps={{
          elevation: 0,
          sx: (theme) => ({
            borderRadius: "0",
            border: darken(theme.palette.background.default, 0.1),
            bgcolor: theme.palette.mode == "dark" ? "#24292e" : "#bdbdbd",
          }),
        }}
        muiTableBodyProps={{
          sx: (theme) => ({
            "& tr:nth-of-type(odd)": {
              backgroundColor: theme.palette.mode == "dark" ? "#24292e" : "#bdbdbd",
            },
          }),
        }}
        onPaginationChange={setPagination}
        state={{ pagination }}
        enableColumnFilterModes={true}
        enableColumnOrdering={true}
        enableColumnFilters={true}
        enableSorting={true}
        enableColumnResizing
        columnResizeMode="onChange"
        enablePinning
        enableRowActions={acciones}
        enableStickyHeader
        initialState={{ showColumnFilters: false, columnVisibility: { id: false }, density: "compact" }}
        positionToolbarAlertBanner="bottom"
        localization={MRT_Localization_ES}
        defaultColumn={{
          maxSize: 400,
          minSize: 40,
        }}
        renderRowActions={({ row, table }) => (
          <Box sx={{ display: "flex", gap: "1rem" }}>
            <Tooltip arrow placement="left" title="Ver">
              <IconButton>
                <VisibilityIcon onClick={() => openModal(row)} />
              </IconButton>
            </Tooltip>
          </Box>
        )}
      />
    </>
  )
}

export default TablaLicencias
